import styled from 'styled-components';
import ThemeHelper from '../../../themes/theme-helper';

export const TopicWrapper = styled.div((props) => {
    const { palette } = ThemeHelper.getTheme(props);

    return `
        .hideRow {
            width: 0;
            display: none;
        }

        .topics {
            border-left: 1px solid ${palette.tertiary.main}
            width: calc(100%/3);
            padding: 10px;
            overflow: auto;
        }
    `;
});

export const TopicPanel = styled.div(`
    height: 100%;

    .topicList {
        padding: 6px;
    }
`);



// WEBPACK FOOTER //
// ./app/components/course-creator/topics/styled.js